<template>
    <div id="side-menu" class="side-menu text-center" @click="stopBubble">
		<span class="close-menu" @click="closeMenu">X</span>
		<a href="https://www.gmvoices.com">
			<img class="menu-logo" src="/images/logo.svg" width="280" height="125" alt="GM Voices">
		</a>
        		
		<div class="menu-side container">
            <ul id="menu-side-menu" class="menu">
                <li id="menu-item-12685" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12685">
                    <a :href="'https://' + website_url + '/why-gm-voices/'">Why GM Voices?</a>
                </li>
                <li id="menu-item-12686" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12686"><a :href="'https://' + website_url + '/about/'">About</a></li>
                <li id="menu-item-12687" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12687"><a :href="'https://' + website_url + '/solutions/'">Voice-Over Solutions</a></li>
                <li id="menu-item-12688" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12688"><a :href="'https://' + website_url + '/media/'">Voice Samples + Media</a></li>
                <li id="menu-item-12689" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-12689"><a :href="'https://' + website_url + '/stories/'">Stories</a></li>
                <li id="menu-item-12690" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-12690"><a :href="'https://' + website_url + '/newsletter/'">Newsletters</a></li>
                <li id="menu-item-12691" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12691"><a :href="'https://' + website_url + '/contact/'">Contact</a></li>
            </ul>
        </div>
		<div class="contact-info">
			<a href="tel:+17707524500">+1 770.752.4500</a>
			<font-awesome-icon icon="circle" />
			<a href="mailto:gmvinfo@gmvoices.com">GMVInfo@gmvoices.com</a>	
		</div>

		<div class="social-icons container">
            <ul id="menu-social-icons" class="menu">
                <li id="menu-item-12692" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-12692"><a href="https://www.facebook.com/gmvoices/"><span class="icon-circle"><font-awesome-icon :icon="['fab', 'facebook-f']" /></span></a></li>
                <li id="menu-item-12693" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-12693"><a href="https://twitter.com/gmvoices"><span class="icon-circle"><font-awesome-icon :icon="['fab', 'twitter']" /></span></a></li>
                <li id="menu-item-12694" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-12694"><a href="https://www.youtube.com/user/GMVoices1"><span class="icon-circle"><font-awesome-icon :icon="['fab', 'youtube']" /></span></a></li>
                <li id="menu-item-12695" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-12695"><a href="https://www.linkedin.com/company/gm-voices"><span class="icon-circle"><font-awesome-icon :icon="['fab', 'linkedin-in']" /></span></a></li>
            </ul>
        </div>	
    </div>
</template>
<script>
    export default {
        data() {
            return {
                website_url: process.env.WEBSITE_URL
            };
        },
        methods: {
            closeMenu () {
                this.$store.commit('toggleMenu')
            },
            stopBubble (e) {
                e.stopPropagation()
            }
        }
    };
</script>


// WEBPACK FOOTER //
// prompts/components/SideMenu.vue